/**
 * Normalized API error. Every failure (server envelope, network, timeout,
 * non-JSON gateway page) ends up as this shape so UI code can switch on `code`.
 *   { status, code, message, details }
 * `status` is 0 when no HTTP response was received.
 * Kept free of axios so pure modules (and their tests) can use it.
 */
export class ApiError extends Error {
  constructor({ status = 0, code = 'UNKNOWN_ERROR', message, details = null }) {
    super(message);
    this.name = 'ApiError';
    this.status = status;
    this.code = code;
    this.details = details;
  }
}

/**
 * i18n key of the message to show a shopper for a failed request. The text is
 * chosen here, from the error's kind, and not taken from `error.message`: the
 * server's messages are written in one language, the UI switches between two.
 */
export function errorMessageKey(error) {
  const code = error && error.code;
  if (code === 'NETWORK_ERROR') return 'errors.network';
  if (code === 'TIMEOUT') return 'errors.timeout';
  if (code === 'SERVER_UNAVAILABLE' || (error && error.status >= 500)) return 'errors.server';
  return 'errors.generic';
}
